/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SelectIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "select", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M16.5 15.5L12.5 19.5L8.5 15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 9.5L12.5 5.5L16.5 9.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SelectIcon);
export default ForwardRef;
//# sourceMappingURL=selectIcon.js.map